import React, { useContext } from "react";
import {
  Checkbox,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
} from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { ClaimContext, ClaimContextType } from "..";
const filterTypes = [
  { id: 5, status: "All" },
  { id: 1, status: "Not Submitted" },
  { id: 2, status: "Submitted" },
  { id: 3, status: "Resubmission" },
  { id: 4, status: "Rejected" },
  { id: 6, status: "Remittance completely received" },
];
function FilterButton() {
  const { filter, setFilter, setRefetch } = useContext(
    ClaimContext,
  ) as ClaimContextType;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  return (
    <>
      <Tooltip title="Filter">
        <IconButton
          color="success"
          onClick={handleClick}
          size="small"
          sx={{ ml: 2 }}
          aria-controls={open ? "account-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
        >
          <FilterAltIcon />
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open || false}
        onClose={handleClose}
        onClick={() => {}}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&::before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        {filterTypes.map((item, index) => (
          <MenuItem
            key={`labelkey${index}`}
            onClick={() => {
              setFilter((prev: any) => ({
                ...prev,
                verificationStatus: item.id,
                flag: item.id,
              }));
              setRefetch(true);
            }}
          >
            <ListItem disablePadding>
              <ListItemIcon>
                <Checkbox
                  checked={filter.verificationStatus == item.id}
                  edge="start"
                  tabIndex={-1}
                  disableRipple
                  inputProps={{ "aria-labelledby": `labelkey${index}` }}
                />
              </ListItemIcon>
              <ListItemText id={`labelkey${index}`} primary={item.status} />
            </ListItem>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export default FilterButton;
